export enum AdminType {
  SUPER_ADMIN = 'Loq Admin',
  ADMIN = 'Customer Admin',
}
